import { useState } from "react";
import { faqData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="container-astro max-w-4xl">
        <AnimatedSection>
          <div className="text-center mb-14 md:mb-18">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-5 font-heading tracking-tight">
              {faqData.heading}
            </h2>
            <div className="w-16 h-1 bg-accent-500 rounded-full mx-auto" />
          </div>
        </AnimatedSection>

        <div className="flex flex-col gap-3">
          {faqData.items.map((item, index) => (
            <AnimatedSection key={index} delay={index * 60}>
              <div
                className={`rounded-xl border transition-all duration-300 ${
                  openIndex === index
                    ? "bg-background-50 border-accent-300/30 shadow-sm"
                    : "bg-background-50 border-background-200/60 hover:border-background-300/60"
                }`}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left"
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                  aria-expanded={openIndex === index}
                >
                  <span className="text-base md:text-lg font-semibold text-foreground-950 font-heading pr-4">
                    {item.q}
                  </span>
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-all duration-300 ${
                      openIndex === index
                        ? "bg-accent-500 text-background-50 rotate-180"
                        : "bg-background-100 text-foreground-500"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line" />
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-400 ${
                    openIndex === index ? "max-h-[400px] opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}